<form [formGroup]="form" (ngSubmit)="submitForm()" class="login-form">
    <div class="message-sent" *ngIf="isShowingConfirmationBubble">
        <div class="message-sent-confirm" qa="message-sent-notification">
            <span class="material-icons themed-icon"> info </span>
            <span>A password reset link has been sent to you.</span>
        </div>
    </div>
    <mat-form-field>
        <input
            matInput
            type="email"
            placeholder="Email"
            [formControl]="emailCtrl"
            [maxlength]="FieldLength.EMAIL_MAX"
            qa="login-email-field"
        />
        <mat-error *ngIf="emailCtrl.errors?.required"
            >Email is required</mat-error
        >
        <mat-error *ngIf="!emailCtrl.errors?.required"
            >Email is invalid</mat-error
        >
    </mat-form-field>
    <mat-form-field>
        <input
            matInput
            type="password"
            placeholder="Password"
            [formControl]="passwordCtrl"
            [maxlength]="FieldLength.PASSWORD_MAX"
            qa="login-password-field"
        />
        <mat-error *ngIf="passwordCtrl.errors?.required">
            Password is required</mat-error
        >
    </mat-form-field>
    <div class="forgot-password-link">
        <a
            (click)="openResetPassword()"
            class="bold-text"
            qa="forgot-password-button"
            >Forgot Password?</a
        >
    </div>
    <div class="form-footer">
        <span class="form-footer-link-text">
            Don't have an account?
            <a
                class="form-footer-link bold-text"
                (click)="openSignUp()"
                qa="sign-up-button"
                >Sign up</a
            >
        </span>
        <button
            type="submit"
            mat-stroked-button
            color="primary"
            class="ols-mat-stroked-button-color"
            qa="gift-card-login-button"
        >
            <span>Log in</span>
        </button>
    </div>
</form>
